import { render, staticRenderFns } from "./fundManagement.vue?vue&type=template&id=64a943c4&scoped=true"
import script from "./fundManagement.vue?vue&type=script&lang=js"
export * from "./fundManagement.vue?vue&type=script&lang=js"
import style0 from "./fundManagement.vue?vue&type=style&index=0&id=64a943c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a943c4",
  null
  
)

export default component.exports